import { gql } from '@apollo/client'

export const GUEST_TOKEN = gql`
  query GuestToken($country: String!) {
    getGuestToken(country: $country)
  }
`
